import React, { useContext, useEffect, useState, useRef } from 'react'
import { Button } from '@mui/material'
import { useHistory } from 'react-router-dom'

import CustomDialog from '@/product/components/organisms/Dialog'

import { mapData } from '@/product/common/components'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
import ReactToPrint from 'react-to-print'
import { currencyFormatWithDecimal } from '@/product/common/components'
// import skyflowContext from '@/product/context/skyflow/skyflowContext'
import { useFormik } from 'formik'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
const PaymentPopUp = (props) => {
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const [openPopup, setOpenPopup] = useState(false)
    const [paymentForm, setPaymentForm] = useState({})
    const handleRedirect = (path) => {
        history.push(`/${path}`)
        window.scrollTo(0, 0)
    }
    const printRef = useRef()

    const controlHubContext = useContext(ControlHubContext)
    const {
        getPendingPayments,
        all_pending_payments,
        paid_payment,
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = controlHubContext
    // const { responseStatus, clearResponse, payCartStripe } =
    //     useContext(skyflowContext)

    const paymentformik = useFormik({
        initialValues: {},

        onSubmit: (values) => {},
    })
    useEffect(() => {
        setPaymentForm({})

        getPendingPayments(
            {
                page: 1,
                limit: 1,
                order: 'desc',
                orderby: 'pay.id',
                filters: {
                    paid: {
                        value: 1,
                        type: 'in',
                        field: 'pay.paid',
                    },
                },
            },
            'lastMonth'
        )
    }, [])

    useEffect(() => {
        if (paid_payment.from === 'lastMonth') {
            if (
                paid_payment &&
                paid_payment.records &&
                paid_payment.records.length
            ) {
                const paymentValue = paid_payment.records.find((ele) => {
                    if (ele.paid) {
                        return ele
                    }
                })

                setPaymentForm(
                    paymentValue !== 'undefined' && paymentValue !== null
                        ? paymentValue
                        : {}
                )
            }
        }
    }, [paid_payment])

    return (
        <>
            <CustomDialog
                title={'Billing Details'}
                open={props.data.popup}
                function={() => props.function(false, 'new', 'lastMonth')}
                closeBtn={() => props.function(false, 'new', 'lastMonth')}
                className="bdModal"
            >
                {paymentForm && Object.keys(paymentForm).length ? (
                    <>
                        <div className="print bdPrint" ref={printRef}>
                            {paymentForm && Object.keys(paymentForm).length && (
                                <>
                                    <div className="bdDetails">
                                        {' '}
                                        <h3>{paymentForm.title}</h3>
                                        <h3>{paymentForm.description}</h3>
                                    </div>

                                    {paymentForm.paymentList?.length > 0 ? (
                                        <div className="mpmTable table-responsive">
                                            <table className="table text-left">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paymentForm.paymentList?.map(
                                                        (data, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    {data.name}
                                                                </td>
                                                                <td>
                                                                    {currencyFormatWithDecimal(
                                                                        data.amount
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                    {paymentForm.tax_percentage &&
                                                    paymentForm.tax_amount ? (
                                                        <>
                                                            <tr>
                                                                <td>
                                                                    {` Total Tax Amount (${paymentForm.tax_percentage}%)`}{' '}
                                                                </td>
                                                                <td>
                                                                    {currencyFormatWithDecimal(
                                                                        paymentForm.tax_amount
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ) : null}
                                                    {paymentForm.card_fee_percentage &&
                                                    paymentForm.card_fee ? (
                                                        <>
                                                            <tr>
                                                                <td>
                                                                    {` Credit Card Fee (${paymentForm.card_fee_percentage}%)`}{' '}
                                                                </td>
                                                                <td>
                                                                    {currencyFormatWithDecimal(
                                                                        paymentForm.card_fee
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                            <div className="mpmTablePayableAmt">
                                                <h6>Total Payable:</h6>
                                                <span>
                                                    {currencyFormatWithDecimal(
                                                        paymentForm.total_amount
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </div>
                        <div className="actionWrapper">
                            <ReactToPrint
                                trigger={() => (
                                    <PrimaryButton
                                        id="print"
                                        // onClick={() =>
                                        //     props.function(false, 'new', 'lastMonth')
                                        // }
                                    >
                                        Print
                                    </PrimaryButton>
                                )}
                                content={() => printRef.current}
                            />
                        </div>
                    </>
                ) : (
                    <h4>No Past Invoice </h4>
                )}
            </CustomDialog>
        </>
    )
}

export default PaymentPopUp
